import "./BiohazardCleanup.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Overview from "./sections/Overview";
import RelatedServices from "./sections/RelatedServices";
import RequestService from "./sections/RequestService";
import Footer from "@/reusable_sections/Footer";
export default function BiohazardCleanupPage() {
  return <div>
      <Header />
      <Hero />
      <Overview />
      <RelatedServices />
      <RequestService />
      <Footer />
    </div>;
}